export default function isApp() {
	if (process.env.PLATFORM === "mobile") {
		return !!(window && typeof (window.App) === "object" &&
			window.App && window.App.app_version) || window.IS_APP_FILE;
	} else {
		return false;
	}
}



// WEBPACK FOOTER //
// ./src/shared/util/isApp.js